var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSparkle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.251 7.62951C13.34 7.40444 13.6592 7.40276 13.7482 7.62784V7.62784C14.7645 10.1989 16.7999 12.2346 19.3709 13.2512V13.2512C19.5964 13.3403 19.5964 13.6595 19.3709 13.7487V13.7487C16.7999 14.7652 14.7645 16.8009 13.7482 19.372V19.372C13.6592 19.5971 13.34 19.5954 13.251 19.3703V19.3703C12.2345 16.8002 10.1997 14.7654 7.6296 13.7489V13.7489C7.40388 13.6596 7.40388 13.3402 7.6296 13.2509V13.2509C10.1997 12.2344 12.2345 10.1996 13.251 7.62951V7.62951Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32761 1.43578C5.38924 1.27997 5.61024 1.2788 5.67184 1.43463V1.43463C6.37545 3.21463 7.78457 4.6239 9.56449 5.3277V5.3277C9.72061 5.38943 9.72061 5.61038 9.56449 5.67211V5.67211C7.78457 6.37591 6.37545 7.78519 5.67184 9.56518V9.56518C5.61024 9.72101 5.38924 9.71985 5.32761 9.56403V9.56403C4.62391 7.78472 3.21518 6.376 1.43588 5.67229V5.67229C1.27961 5.61049 1.27961 5.38933 1.43588 5.32752V5.32752C3.21518 4.62382 4.62391 3.21509 5.32761 1.43578V1.43578Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/sparkle.a0d85358ce3ce632f4d5025d7cb15fb6.svg";
export { ForwardRef as ReactComponent };